/**
 * B2G2 Cart Bundle Helper
 * Handles bundle removal from the cart drawer.
 * Uses event delegation + XMLHttpRequest to avoid fetch interceptors from Gokwik/Bundler apps.
 */
(function () {
  'use strict';

  var isRemoving = false;

  /* --- XHR wrapper (Gokwik monkey-patches window.fetch, so we use XHR) --- */
  function cartXHR(method, url, data) {
    return new Promise(function (resolve, reject) {
      var xhr = new XMLHttpRequest();
      xhr.open(method, url, true);
      xhr.setRequestHeader('Content-Type', 'application/json');
      xhr.onload = function () {
        if (xhr.status >= 200 && xhr.status < 400) {
          try { resolve(JSON.parse(xhr.responseText)); }
          catch (e) { resolve(xhr.responseText); }
        } else {
          reject(new Error('B2G2 cart request failed: ' + xhr.status));
        }
      };
      xhr.onerror = function () { reject(new Error('B2G2 network error')); };
      if (data) { xhr.send(JSON.stringify(data)); }
      else { xhr.send(); }
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.b2g2-bundle-remove-btn');
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();
    if (isRemoving) return;
    isRemoving = true;

    /* A Buy 2 Get 2 button carries data-bundle-id; a Diwali combo button carries data-combo-ref
       (same row markup). groupProp is the line property that ties a group's lines together. */
    var bundleId = btn.dataset.bundleId;
    var groupProp = '_b2g2_bundle_id';
    if (!bundleId && btn.dataset.comboRef) {
      bundleId = btn.dataset.comboRef;
      groupProp = '_combo_ref';
    }
    if (!bundleId) { isRemoving = false; return; }

    var wrapper = btn.closest('.b2g2-bundle-wrapper');
    if (wrapper) {
      wrapper.style.opacity = '0.4';
      wrapper.style.pointerEvents = 'none';
    }

    /* The row lists its lines' keys (snippets/cart-drawer.liquid), so the bundle goes in one
       request. Without them, its lines are looked up in the live cart as before. Only
       "variantId:hash" keys are sent: a bare number would be read as a variant id. */
    var row = btn.closest('[data-line-keys]');
    var lineKeys = row ? row.getAttribute('data-line-keys').split(',').filter(function (key) { return key.indexOf(':') > 0; }) : [];

    (lineKeys.length ? removeByKeys(lineKeys, bundleId, groupProp) : removeByBundleId(bundleId, groupProp))
      .catch(function (err) {
        console.error('B2G2 bundle removal error:', err);
        if (wrapper) {
          wrapper.style.opacity = '1';
          wrapper.style.pointerEvents = '';
        }
      })
      .finally(function () {
        isRemoving = false;
      });
  });

  /* Sequential path: read the live cart, remove the bundle's lines one by one, re-render. */
  function removeByBundleId(bundleId, groupProp) {
    groupProp = groupProp || '_b2g2_bundle_id';
    return cartXHR('GET', '/cart.js')
      .then(function (cartData) {
        var keys = [];
        cartData.items.forEach(function (item) {
          if (item.properties && item.properties[groupProp] === bundleId) {
            keys.push(item.key);
          }
        });

        if (keys.length === 0) return Promise.resolve();

        return keys.reduce(function (chain, key) {
          return chain.then(function () {
            return cartXHR('POST', '/cart/change.js', { id: key, quantity: 0 });
          });
        }, Promise.resolve());
      })
      .then(function () {
        return refreshCartDrawer();
      });
  }

  /* All of the bundle's lines in ONE /cart/update.js, with the drawer sections in the same
     response, so a failure between requests can no longer leave the bundle half removed.
     A refused or unexpected response takes the sequential path, which checks the live
     cart: Shopify can apply an update and still answer 400, and a rendered key can be out
     of date. */
  function removeByKeys(lineKeys, bundleId, groupProp) {
    var updates = {};
    lineKeys.forEach(function (key) { updates[key] = 0; });
    /* Replaced by any other drawer re-render that lands while the request is out. */
    var itemsAtSend = document.querySelector('#CartDrawer cart-drawer-items');

    return cartXHR('POST', '/cart/update.js', {
      updates: updates,
      sections: 'cart-drawer,cart-icon-bubble',
      sections_url: window.location.pathname
    })
      .then(function (cart) {
        if (!cart || !Array.isArray(cart.items) || cart.status) throw new Error('B2G2 unexpected cart response');
        return cart;
      })
      .then(function (cart) {
        /* A line of the bundle is still in the cart (the drawer was out of date): finish as before. */
        if (hasBundleLines(cart, bundleId, groupProp)) return removeByBundleId(bundleId, groupProp);
        /* A section failed to render (null) or a newer render landed meanwhile: re-fetch, as before. */
        if (document.querySelector('#CartDrawer cart-drawer-items') !== itemsAtSend || !paintDrawer(cart.sections, cart.item_count)) {
          return refreshCartDrawer();
        }
      }, function (err) {
        console.warn('B2G2 bundle update failed, removing line by line:', err);
        return removeByBundleId(bundleId, groupProp);
      });
  }

  function hasBundleLines(cart, bundleId, groupProp) {
    groupProp = groupProp || '_b2g2_bundle_id';
    return cart.items.some(function (item) {
      return !!(item && item.properties && item.properties[groupProp] === bundleId);
    });
  }

  /* The drawer is open: swap .drawer__inner and the header bubble only, never #CartDrawer,
     whose overlay holds the click-to-close listener. False when a section is missing. */
  function paintDrawer(sections, itemCount) {
    var currentInner = document.querySelector('#CartDrawer .drawer__inner');
    if (!currentInner || !sections || !sections['cart-drawer'] || !sections['cart-icon-bubble']) return false;
    var parser = new DOMParser();
    var newInner = parser.parseFromString(sections['cart-drawer'], 'text/html').querySelector('.drawer__inner');
    if (!newInner) return false;
    currentInner.innerHTML = newInner.innerHTML;

    var newBubble = parser.parseFromString(sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
    var currentBubble = document.getElementById('cart-icon-bubble');
    if (newBubble && currentBubble) currentBubble.innerHTML = newBubble.innerHTML;

    var cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) cartDrawer.classList.toggle('is-empty', itemCount === 0);
    return true;
  }

  function refreshCartDrawer() {
    var cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) {
      window.location.reload();
      return Promise.resolve();
    }

    return sectionFetch('/cart?section_id=cart-drawer')
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        /* .drawer__inner only: replacing #CartDrawer would drop the overlay's close listener. */
        var newInner = doc.querySelector('.drawer__inner');
        var currentInner = document.querySelector('#CartDrawer .drawer__inner');
        if (newInner && currentInner) {
          currentInner.innerHTML = newInner.innerHTML;
        }

        return sectionFetch('/cart?section_id=cart-icon-bubble');
      })
      .then(function (bubbleHtml) {
        var bubbleDoc = new DOMParser().parseFromString(bubbleHtml, 'text/html');
        var newBubble = bubbleDoc.querySelector('.shopify-section');
        var currentBubble = document.getElementById('cart-icon-bubble');
        if (newBubble && currentBubble) {
          currentBubble.innerHTML = newBubble.innerHTML;
        }

        return cartXHR('GET', '/cart.js');
      })
      .then(function (cart) {
        var cd = document.querySelector('cart-drawer');
        if (cart.item_count === 0 && cd) {
          cd.classList.add('is-empty');
        }
      });
  }

  /* Section fetch uses XHR too for consistency */
  function sectionFetch(url) {
    return new Promise(function (resolve, reject) {
      var xhr = new XMLHttpRequest();
      xhr.open('GET', url, true);
      xhr.onload = function () {
        if (xhr.status >= 200 && xhr.status < 400) {
          resolve(xhr.responseText);
        } else {
          reject(new Error('Section fetch failed: ' + xhr.status));
        }
      };
      xhr.onerror = function () { reject(new Error('Network error')); };
      xhr.send();
    });
  }
})();
